import React from 'react'
import { Linking } from 'react-native'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import {
  WorkLifeIconDependentCare,
  WorkLifeIconFamily,
  WorkLifeIconFinancial,
  WorkLifeIconMindfulness,
} from '../atoms/icons/WorkLifeIcons'
import { Link } from '../atoms/link/Link'
import { CardDescription as WorkLifeCardDescription } from '../organisms/workLifeCard/WorkLifeCard'

/* eslint-disable formatjs/no-literal-string-in-jsx */

export const thehartford: GetCustomerCopyFunc = () => {
  return {
    workLifeServices: [
      {
        identifiers: {
          id: 'careAtWork',
          dataTestId: 'workLife-selectCareAtWork',
        },
        title: 'Care @ Work',
        iconSvg: <WorkLifeIconDependentCare size={48} />,
        paragraph: (
          <>
            <WorkLifeCardDescription text='The Hartford provides – at no cost to you – unlimited access to ' />
            <Link
              text='Care.com'
              onPress={() => {
                Linking.openURL('https://care.com/')
              }}
            />
            <WorkLifeCardDescription text=", the world's largest online community for finding care, including nannies, tutors, senior caregivers, housekeepers, and more. Sign up at " />
            <Link
              text='care.com/thehartford'
              onPress={() => {
                Linking.openURL('http://care.com/thehartford')
              }}
            />
            <WorkLifeCardDescription text='.' />
          </>
        ),
        bullets: [],
      },
      {
        identifiers: {
          id: 'peaceAtHome',
          dataTestId: 'workLife-selectPeaceAtHome',
        },
        title: 'Peace at Home Parenting Solutions',
        iconSvg: <WorkLifeIconMindfulness size={48} />,
        paragraph: (
          <>
            <WorkLifeCardDescription
              text='Access to live and recorded online parenting classes at no cost to you. Classes
              include topic such as Back to School with Joy and Optimism, Positive Discipline, School Success –
              Inspire Motivation and Engagement, and more. '
            />
            <Link
              text='Learn more'
              onPress={() => {
                Linking.openURL('https://www.cafewell.com/pages/full?id=hartpah21')
              }}
            />
          </>
        ),
        bullets: [],
      },
      {
        identifiers: {
          id: 'mavenFamily',
          dataTestId: 'workLife-selectMavenFamily',
        },
        title: 'Maven Family Benefits',
        iconSvg: <WorkLifeIconFamily size={48} />,
        paragraph: (
          <>
            <WorkLifeCardDescription
              text='Get unlimited, on-demand support for fertility, pregnancy, adoption, surrogacy,
              postpartum, returning to work, and infant care with Maven. '
            />
            <Link
              text='Learn more'
              onPress={() => {
                Linking.openURL('https://www.cafewell.com/pages/full?id=hart_mav21')
              }}
            />
          </>
        ),
        bullets: [],
      },
      {
        identifiers: {
          id: 'perksAtWork',
          dataTestId: 'workLife-selectPerksAtWork',
        },
        title: 'Perks at Work',
        iconSvg: <WorkLifeIconFinancial size={48} />,
        paragraph: (
          <>
            <WorkLifeCardDescription
              text='Check out Perks at Work for back-to-school savings and access to enrichment programs
              for children. '
            />
            <Link
              text='Sign in Here.'
              onPress={() => {
                Linking.openURL('https://www.perksatwork.com/login')
              }}
            />
          </>
        ),
        bullets: [],
      },
      {
        identifiers: {
          id: 'brightHorizons',
          dataTestId: 'workLife-selectBrightHorizons',
        },
        title: 'Bright Horizons',
        iconSvg: <WorkLifeIconFamily size={48} />,
        paragraph: '',
        bullets: [
          'Help finding caregiving support for infants to elders',
          'Backup care when regular arrangements fall through',
          'Educational resources and tutoring discounts',
        ],
        CTA: 'Access Bright Horizons',
        PATH: 'https://clients.brighthorizons.com/thehartford',
      },
    ],
  }
}
